import { Plus } from 'react-feather'
import Button from '@/components/Button/Button'

const PADDING = 20

const IconLabelButton = ({ onClick, iconComponent, text, size = 16 }) => {
  const buttonSize = size + PADDING

  return (
    <div className="flex flex-row justify-start items-center">
      <Button
        variant="icon"
        className="flex flex-row justify-center items-center rounded-lg hover:bg-themed-blue-400/15 transition-colors duration-75"
        style={{ width: `${buttonSize}px`, height: `${buttonSize}px` }}
        onClick={onClick}
      >
        {iconComponent || (
          <Plus size={size} className="text-themed-blue-400 mt-1" />
        )}
      </Button>
      <span
        onClick={onClick}
        className="cursor-pointer text-label pl-4 font-bold"
      >
        {text || 'Add another'}
      </span>
    </div>
  )
}

export default IconLabelButton
